module.exports = __webpack_public_path__ + "static/media/piedrawing.136920a4.jpg";